export const isNumber = (value) => {
    return typeof value === "number" && !Number.isNaN(value);
};
export const isString = (value) => {
    return typeof value === "string";
};
export const isStringNotEmpty = (value) => {
    return isString(value) && value.replace(/\s/g, "") !== "";
};
export const isUndefinedString = (value) => {
    return ["undefined", "NaN"].includes(`${value}`);
};
export const isDefined = (value) => {
    return value !== null && typeof value !== "undefined" && !isUndefinedString(value);
};
//# sourceMappingURL=type-check.js.map
